import { ReactNode } from 'react';

interface ContentPanelProps {
    children: ReactNode;
    headerText: string;
    className?: string; // Optional additional classes
}

export const ContentPanel = ({ children, headerText, className = '' }: ContentPanelProps) => {
    return (
        <div className={`bg-gray-500 p-8 mx-auto text-center text-white ${className}`}>
            <div className="prose max-w-none">
                <h2 className="text-xl text-white mb-4">{headerText}</h2>

                {children}
            </div>
        </div>
    );
};